import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Web implementation of Google Sign-In using Supabase OAuth redirect flow
 */
export function useGoogleSignIn(onSuccess?: () => void) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signIn = useCallback(async (): Promise<{ success: boolean; cancelled: boolean }> => {
    try {
      setLoading(true);
      setError(null);

      // Use Supabase OAuth redirect flow for web
      const { data, error: oauthError } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/`,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          },
        },
      });

      if (oauthError) {
        throw oauthError;
      }

      // OAuth redirect will happen, so this code may not execute
      // The success callback will be handled by the auth state change listener
      return { success: true, cancelled: false };
    } catch (err: any) {
      console.error('Google Sign-In error (web):', err);
      const errorMessage = err.message || err.toString() || '';
      setError(errorMessage || 'Google Sign-In failed');
      return { success: false, cancelled: false };
    } finally {
      setLoading(false);
    }
  }, []);

  return { signIn, loading, error };
}

